import { env } from './env'

const endPoints = {

    /* Client APIs */
    allClients: env.baseUrl + 'api/Client/AllClients',
    addClient: env.baseUrl + 'api/Client/AddClient',
    updateClient: env.baseUrl + 'api/Client/UpdateClient',

    /* Reports APIs */
    allInventory: env.baseUrl + 'Api/Inbound/Inventory',
    
    /* Task APIs */
    allTasks: env.baseUrl + 'api/Services/All',
    newTask: env.baseUrl + 'api/Services/NewTask',
    addTask: env.baseUrl + 'api/services/InsertDetails',
    editTask: env.baseUrl + 'api/services/edittask?id=',
    editCommunicationCategory: env.baseUrl + 'api/services/EditConfig?ServiceTaskId=',
    updateTask: env.baseUrl + 'api/services/InsertDetails',
    updateDataSecurity: env.baseUrl + 'Api/services/UpdateDataSecurity',
    deleteDrugPrice: 'api/product/DeleteDrug?NDC=',
    // http://192.168.1.117:9090/Api/services/UpdateDataSecurity
    
}

export default endPoints